import type { ProgressStepId } from 'api/onboarding/progress';
import { ONBOARDING_STEPS } from 'containers/OnboardingWizard/steps';
import { ONBOARDING_SOURCE } from 'constants/analytics';
import { logException } from 'helpers/loggers';

// keyed by the backend's step id and sent as step_name, so route slugs and rail order can change
function stepName(id: ProgressStepId) {
  const step = ONBOARDING_STEPS.find(({ progressStepId }) => progressStepId === id);

  if (!step) {
    logException({
      message: 'onboarding analytics step not found',
      error: null,
      context: { id },
      tags: null,
    });
    return {};
  }

  return { step_name: step.analyticsStepName };
}

export function onboardingAttributes(id?: ProgressStepId): {
  source: typeof ONBOARDING_SOURCE;
  step_name?: string;
} {
  return { source: ONBOARDING_SOURCE, ...(id && stepName(id)) };
}

// shared menu events only know they came from onboarding by their source
export function onboardingStepFor(source?: string) {
  return source === ONBOARDING_SOURCE ? onboardingAttributes('menu_builder') : {};
}
